// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { CStampFreeText_abstract } from './../abstract/SagaSchema/CStampFreeText_abstract';

export class CStampFreeText extends CStampFreeText_abstract {
  get icon() {
    return 'chatbox-ellipses';
  }
}
